import type { ReactNode } from 'react'
import styles from './notice.module.css'

export interface NoticeProps {
  title: ReactNode
  children?: ReactNode
  actions?: ReactNode
}

/** Экран-сообщение: вход закрыт, нет связи, нет доступа. */
export function Notice({ title, children, actions }: NoticeProps) {
  return (
    <main className={styles.notice}>
      <h1 className={styles.title}>{title}</h1>
      {children !== undefined && <div className={styles.text}>{children}</div>}
      {actions !== undefined && <div className={styles.actions}>{actions}</div>}
    </main>
  )
}

/** Загрузка всего экрана: подпись читается скринридером. */
export function Loading({ label = 'Загружаем' }: { label?: string }) {
  return (
    <main className={styles.notice} aria-busy="true">
      <span className={styles.spinner} />
      <span className="visually-hidden" role="status">
        {label}
      </span>
    </main>
  )
}
